var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bunny-player-wrapper"},[(_vm.videoUrl)?_c('div',{staticClass:"video-container",style:({
      maxWidth: _vm.width ? (_vm.width + "px") : '100%',
      maxHeight: _vm.height ? (_vm.height + "px") : '100%'
    })},[_c('iframe',{attrs:{"src":_vm.videoUrl,"title":_vm.bunnyVideo.title || 'Video Player',"loading":"lazy","allow":"accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;","allowfullscreen":"true"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }